export default __webpack_public_path__ + "static/media/Offerings.f5dc0d7b.svg";